import React, { type ReactElement } from 'react';
import clsx from 'clsx';
import type { GetPropsCommonOptions, UseComboboxGetInputPropsOptions } from 'downshift';
import styles from './item-input.module.scss';

type Props = {
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  hasError: boolean;
  getInputProps: (
    options?: UseComboboxGetInputPropsOptions,
    otherOptions?: GetPropsCommonOptions
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  onBlur: (() => void) | undefined;
  isValueFromInputProps: boolean;
};

export default function ItemInput({
  id,
  placeholder,
  disabled,
  hasError,
  getInputProps,
  onBlur,
  isValueFromInputProps
}: Props): ReactElement {
  return (
    <input
      placeholder={placeholder ?? 'Select...'}
      className={clsx(styles.itemInput, { [`${styles.itemInputWithError}`]: hasError })}
      disabled={disabled}
      // Add input props explicitly only if used, rather than spreading getInputProps(). We want to
      // be able to control some props such as the ID and the input value from outer components.
      id={id || getInputProps().id}
      ref={getInputProps().ref} // Prevent console error
      onClick={getInputProps().onClick}
      onChange={getInputProps().onChange}
      onBlur={onBlur || getInputProps().onBlur}
      autoComplete={getInputProps().autoComplete} // Prevent browser from displaying previous searches.
      aria-autocomplete={getInputProps()['aria-autocomplete']}
      // Needed for multi combo boxes because getInputProps doesn't update on every render:
      value={isValueFromInputProps ? getInputProps().value : ''}
    />
  );
}
